module.exports = __webpack_public_path__ + "img/Comic03-1.c0eb9c2e.png";